import { Form, Typography } from "antd";
import AppContent from "common/AppContent";
import AppPageHeader from "common/PageHeader";
import ExtraContent from "components/Configuration/CommonComponents/ExtraContent";
import { NO_PERMISSION_REQUIRED } from "routes/permissions";
import { hasPermission } from "utils/functions";
import ImportInvoiceForm from "../Form";

// Antd Constants
const { Title } = Typography;
export default function ImportInvoiceExpenseCreate() {
  const [form] = Form.useForm();

  return (
    <>
      <AppContent
        header={
          <AppPageHeader
            extra={
              <ExtraContent
                hideFilterButton
                addButtonText={
                  hasPermission([NO_PERMISSION_REQUIRED])
                    ? "Add New"
                    : "No Permission"
                }
                handleAddItemOpen={() => form.submit()}
              />
            }
            title={<Title level={5}>Import Invoice Expense Create</Title>}
          />
        }
        content={
          <>
            <ImportInvoiceForm form={form} />
          </>
        }
      />
    </>
  );
}
